import React, { Component } from "react";
import { connect } from "react-redux";

import { Container } from "app/NativeComponents/common";

import Body from "./Body";
class LeadStatuses extends Component {
  render() {
    return (
      <Container
        style={{
          display: "flex",
          alignSelf: "stretch",
          backgroundColor: this.props.colors.card_color
        }}
      >
        <Body />
      </Container>
    );
  }
}

const mapStateToProps = ({ settings, native }) => {
  const { colors } = settings;
  const { platform, device, isMobile } = native;

  return {
    colors,
    device,
    isMobile,
    platform
  };
};

export default connect(mapStateToProps, {})(LeadStatuses);
